import { useEffect, useState } from 'react';
import { fetchSubtreeRollup, type SubtreeRollup } from '@/api/subtreeRollup';

/**
 * Ticket 124.6c — loads the caller tenant's subtree roll-up.
 *
 * Only fetches when `enabled` is true (the caller gates this on being a
 * parent tenant, so leaf tenants never hit the endpoint). On error
 * (e.g. a 403 for a non-TENANT_ADMIN) it silently resolves to null so
 * the consuming section self-hides.
 */
export function useSubtreeRollup(enabled: boolean) {
  const [data, setData] = useState<SubtreeRollup | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setData(null);
      return;
    }
    let active = true;
    setLoading(true);
    fetchSubtreeRollup()
      .then((rollup) => {
        if (active) setData(rollup);
      })
      .catch(() => {
        if (active) setData(null);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, [enabled]);

  return { data, loading };
}
